import { req } from "@/utils/httpRequest";
import * as constant from "@/common/common.const";

const prefix = process.env.VUE_APP_FILE_SYS_URL;

const downloadUri = prefix + "/file/download";
const uploadUri = prefix + "/file/upload";

//生成下载外链地址
const generateDownloadLink = fileId => {
  return downloadUri + constant.DELIMITER_SLASH + fileId;
};

const download = fileId => {
  let url = generateDownloadLink(fileId);
  window.open(url, "_self");
  // return get(url)
};

const upload = formData => {
  let requestConfig = {
    showLoading: false,
    url: uploadUri,
    method: "post",
    data: formData,
    headers: {
      "Content-Type": "multipart/form-data"
    }
  };
  return req(requestConfig);
};

export default {
  generateDownloadLink,
  download,
  upload
};
